import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Clear, Search } from '@material-ui/icons'
import { getQueryStringValue, getUserSFId } from '../../Utility/Utility.js'

const SearchSavedSearch = props => {
    const { handleChange, inputSearchSaved, setInputSearchSaved } = props

    const [view, setView] = useState(getQueryStringValue('view') ? getQueryStringValue('view') : 'savedList')
    // const [inputSearchSaved, setInputSearchSaved] = useState(getQueryStringValue('searchTerm') ? getQueryStringValue('searchTerm') : '')

    // useEffect(() => {
    //     setView(getQueryStringValue('view') ? getQueryStringValue('view') : 'savedList')
    // }, [getQueryStringValue('view')])

    // const handleChange = e => {
    //     const { value } = e.target
    //     setInputSearchSaved(value)
    //     updateSearchTerm(value)
    // }

    // const handleClear = () => {
    //     setInputSearchSaved('')
    //     // updateSearchTerm('')
    // }

    // const updateSearchTerm = value => {
    //     let queryParam = `userId=${getUserSFId()}&view=${view}&searchTerm=${value}`
    //     window.history.pushState({}, 'Property Search', '/PropertySearch?' + queryParam)
    // }

    return (
        <>
            <div className="bg-gray-15 flex flex-row items-center bg-white text-base pl-3 pr-4 rounded rounded-pill w-full md:w-1/2">
                <Search fontSize="small"></Search>
                <input data-testid="test-search-list-saved-search" onChange={handleChange} value={inputSearchSaved} type="text" placeholder={`${view === 'savedList' ? 'Search List' : 'Search Saved Search'}`} className="w-full form-control border-0 text-base bg-gray-15">
                </input>
                {inputSearchSaved !== '' &&
                    <a className="text-base" href="#" onClick={() => { setInputSearchSaved('') }}>
                        <Clear data-testid="test-btn-clear-search-list-search" fontSize="small"></Clear>
                    </a>
                }
            </div>
        </>
    )
}

SearchSavedSearch.propTypes = {
    handleChange: PropTypes.any,
    inputSearchSaved: PropTypes.any,
    setInputSearchSaved: PropTypes.any
}


export default SearchSavedSearch
